const interfacePhrases = {
    rate_limited: '頻率受限',
    limit_exceeded: '超出限額',
    used: '使用',
    identifier: '識別碼',
    verification: '驗證',
    messages: '訊息',
    data: '資料',
    custom: '自訂',
    management_api: '{{product}} 管理介面',
    management_api_role_description: '此內建角色授予管理介面的存取權限。',
    client_credentials: '用戶端憑證',
    authentication_request: '身分驗證請求',
    callback: '身分驗證回呼',
    help_title: 'iden說明中心',
    help_subtitle: '無需離開目前頁面即可查看說明',
    open_help: '開啟完整說明頁面',
    close_help: '關閉說明',
    about: '關於與開源聲明',
    open_navigation: '開啟導覽',
    close_navigation: '關閉導覽',
    development_enabled: '已啟用開發功能',
    beta: '測試版',
    impersonation: '身分模擬',
    key: '鍵',
    value: '值',
    error: '錯誤',
    details: '技術詳情',
    callback_failed: '無法完成登入回呼。',
    back_sign_in: '返回登入',
    powered_by: '技術支援：',
    avatar: '頭像',
    logo: '標誌',
    qr_code: '二維碼',
    sample_title: '想查看範例嗎？',
    sample_description: '查看使用本指南的範例應用程式。',
    sample_action: '查看範例',
    further_readings: '延伸閱讀',
    complete_guide: '完整指南',
    custom_domains_notice: '新增<a>自訂網域</a>後，可以使用以下端點：<code>{{endpoint}}</code>。',
    my_project: '我的專案',
    my_secret: '我的密鑰',
    my_token: '我的權杖',
    role_example: '檢視者',
    reset_retry: '重設設定並重試',
    open_dev_panel: '開啟開發者面板',
    close_dev_panel: '關閉開發者面板',
    configuration: '設定',
    app_id: '應用程式識別碼',
    extra_parameters: '附加登入參數',
    prompt: '身分驗證提示',
    scope: '範圍',
    resource: '資源',
    resources_space_delimited: '資源（以空格分隔）',
    sign_out_to_apply: '登出後即可套用變更。',
    refresh_token_grant: '重新整理權杖授權',
    organization_id: '組織識別碼',
    console_result: '請在瀏覽器主控台查看結果。',
    request_token: '請求權杖',
    user_info: '使用者資訊',
    get_id_token_claims: '取得身分權杖宣告',
    fetch_user_info: '取得使用者資訊',
    device_initializing: '正在初始化裝置授權…',
    device_success: '你已成功登入示範應用程式。',
    sign_in_information: '你的登入資訊：',
    email: '電子郵件',
    username: '使用者名稱',
    user_id: '使用者識別碼',
    sign_out_demo: '登出示範應用程式',
    device_expired: '裝置驗證碼已過期',
    generic_error: '發生錯誤',
    device_expired_description: '裝置驗證碼已過期，請重試以取得新驗證碼。',
    sign_in_title: '登入你的帳戶',
    scan_instruction: '掃描二維碼，或在其他裝置上開啟以下網址：',
    one_time_code: '輸入一次性驗證碼',
    token_info: '權杖資訊',
    get_access_token: '取得存取權杖',
    context_unavailable: '無法載入帳戶資訊。',
    not_initialized: '帳戶資訊尚未初始化。',
    not_set: '未設定',
    configured: '已設定',
    password: '密碼',
    phone: '電話號碼',
    search_help: '搜尋說明',
    language: '語言',
    menu: '選單',
    compatibility_notice: '相容性說明：繼承自Logto的開發工具套件、套件、協定、元件及請求標頭名稱保持不變。',
    source: '來源',
    upstream_repository: '上游儲存庫',
    current_fork: '目前儲存庫',
    license_notice: 'iden以Logto為基礎建置；Logto是依Mozilla公共授權條款 2.0 授權的開源軟體。',
    about_description: '產品資訊與開源聲明。',
    page_not_found: '找不到頁面',
    page_not_found_description: '此頁面無法使用，請返回說明中心繼續瀏覽。',
    introduction: '簡介',
    quick_starts: '快速入門',
    integration: '整合',
    end_user_flows: '終端使用者流程',
    authorization: '授權',
    user_management: '使用者管理',
    security: '安全性',
    customization: '自訂',
    connectors: '連接器',
    organizations: '組織',
    self_hosting: '自行託管',
    continue: '繼續',
    loading: '載入中…',
    save: '儲存',
    saved: '已儲存',
    try_again: '重試',
    client_id: '用戶端識別碼',
    client_secret: '用戶端密鑰',
    redirect_uri: '重新導向網址',
    status: '狀態',
    type: '類型',
    permissions: '權限',
    token_data: '權杖資料',
    context_data: '情境資料',
    jwt_extra_claims: '附加權杖宣告',
    action_result: '操作結果',
    social_account_already_linked: '此社交帳號已連結。',
};
export default Object.freeze(interfacePhrases);
